<template>
  <transition name="PaB-modal">
    <div class="PaB-modal-mask">
      <div class="PaB-modal-outer" :style="frameStyles" @click="closeOnMask" ref="modal">
        <div class="PaB-modal-wrapper" :style="{maxWidth: width}">
          <button class="PaB-modal__close" @click="close">
            <icon-base icon-name="Close">
              <icon-close />
            </icon-base>
          </button>
          <div class="PaB-modal-container PaB-modal">
            <div class="PaB-modal__header">
              <slot name="header"></slot>
            </div>

            <div class="PaB-modal__body">
              <slot name="body"></slot>
            </div>

            <div class="PaB-modal__footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.PaB-modal-mask {
  transition: opacity 0.1s linear;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.PaB-modal-outer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition: top 0.1s linear;
}
.PaB-modal-wrapper {
  margin: auto;
  width: 100%;
  padding: 15px;
  position: relative;
}
.PaB-modal {
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  width: 100%;
  margin-top: 35px;
  position: relative;
}

.PaB-modal__close {
  position: absolute;
  right: 15px;
  color: #fff;
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
}

.PaB-modal-container {
  overflow: hidden;
}

.PaB-modal__body {
  position: relative;
}

// Modal transitions
.PaB-modal-enter {
  opacity: 0;
}

.PaB-modal-leave-active {
  opacity: 0;
}

.PaB-modal-enter .PaB-modal,
.PaB-modal-leave-active .PaB-modal {
  transform: scale(0.8);
}
</style>

<script>
import IconBase from '@/components/IconBase'
import IconClose from '@/components/icons/IconClose'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { clamp } from '@/helpers/utils'

export default {
  components: {
    IconBase,
    IconClose
  },
  props: {
    modalMode: {
      type: Boolean,
      default: false
    },
    escClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '900px'
    }
  },

  computed: {
    isIframe () {
      return this.$store.state.iframe.isIframe
    },
    frameStyles () {
      if (!this.isIframe) {
        return {}
      }

      var frame = this.$store.state.iframe.info
      var modalHeight = Math.min(frame.iframeHeight, frame.clientHeight)
      var modalMaxTop = Math.max(frame.iframeHeight - frame.clientHeight, 0)
      var clampedTop = clamp(frame.scrollTop - frame.offsetTop, 0, modalMaxTop)

      var style = {
        top: clampedTop + 'px',
        height: modalHeight + 'px'
      }
      return style
    }
  },

  mounted () {
    window.addEventListener('keyup', this.closeOnEscape)
    this.$nextTick(() => {
      disableBodyScroll(this.$refs.modal)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.closeOnEscape)
    enableBodyScroll(this.$refs.modal)
  },

  methods: {
    close () {
      this.$emit('close')
    },
    closeOnEscape (e) {
      if (!this.escClose) { return }

      if (e.keyCode === 27) {
        this.close()
      }
    },
    closeOnMask (e) {
      if (this.modalMode) { return }

      if (e.target === this.$refs.modal) {
        this.close()
      }
    }
  }
}
</script>
